import React from "react";

const FormRange = ({
    entity,
    fieldName,
    handleChange,
    label,
    min = 0,
    max = 100,
    step = 1,
    mb = 3
}: {
    entity: any;
    fieldName: string;
    handleChange: any;
    label?: string;
    min?: number;
    max?: number;
    step?: number;
    mb?: number;
}) => {
    return (
        <div className={`${mb && mb > 0 && `mb-${mb}`}`}>
            <label htmlFor={fieldName} className="form-label">{label ? label : fieldName}</label>
            <input type="range" className="form-range" min={min} max={max} step={step} id={fieldName} value={entity[fieldName] ?? ''} onChange={handleChange}></input>
        </div>
    )
}

export default FormRange;